import { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { Button, TextField } from '@mui/material';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postComment } from '../../../components/Comments/apiService';

import { useDialogForm } from '../../../contexts/DialogForm';

import useSnackbarStore from '../../../store/snackbar';

import ChatRoundedIcon from '@mui/icons-material/ChatRounded';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 1rem;
  margin: 1rem 0;
`;

const CommentSection = ({ resource, resource_id, invalidate_queries = [] }) => {

  const queryClient = useQueryClient();

  const showSnackbar = useSnackbarStore((state) => state.showSnackbar);

  const [comment, setComment] = useState('');

  const { handleClose } = useDialogForm() || {};

  const { mutate } = useMutation({
    mutationFn: () => postComment(comment, resource, resource_id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['timeline']});
      if (invalidate_queries?.length) invalidate_queries.forEach((query) => queryClient.invalidateQueries({ queryKey: query }));
      showSnackbar("Successfully posted comment", "success");
      setComment('');
      if (handleClose) handleClose();
    },
    onError: () => {
      showSnackbar("Failed to post comment", "error");
    }
  })
  return (
    <Container>
      <TextField placeholder='use @user to tag another user' multiline fullWidth minRows={3} slotProps={{input: {sx: {p: ".8rem"}}}} onChange={(e) => setComment(e.target.value)} value={comment} />
      <Button variant="outlined" size="small" startIcon={<ChatRoundedIcon />} onClick={() => mutate()}>Post Comment</Button>
    </Container>
  );
};

export default CommentSection;